import { call, put, takeLatest } from "redux-saga/effects";

import { apiGetListArticles } from "helpers/api/articles";
import {
  GET_ARTICLES,
  actGetListArticlesFailed,
  actGetListArticlesSuccess,
} from "store/actions/articles";
import { showToastError } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListArticle(action) {
  try {
    const response = yield call(apiGetListArticles, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actGetListArticlesSuccess(response));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
      // showToastSuccess(
      //     'success',
      // )
    }
  } catch (error) {
    yield put(actGetListArticlesFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchGetList() {
  yield takeLatest(GET_ARTICLES, doGetListArticle);
}
